export enum OutboxMessageTitles {
  CustomerProfile = "livechat:customer_profile",
  TicketInfo = "livechat:ticket_info",
  ActionButton = "livechat:action_button",
  CustomerDetailsSectionButtonClick = "livechat:customer_details_section_button_click",
  MessageBoxText = "livechat:message_box_text",
  MessageSent = "livechat:message_sent",
}
